var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    fill: "#FDFDFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#CDCED7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 18.999H30.0002C30.0002 13.869 26.1272 10 20.9902 10V12C25.0522 12 28.0002 14.943 28.0002 18.999Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 16C23.1033 16 24.0003 16.897 24.0003 19H26.0003C26.0003 15.775 24.2253 14 21.0003 14V16ZM24.4223 21.443C24.2301 21.2683 23.9776 21.1752 23.7181 21.1832C23.4585 21.1912 23.2123 21.2998 23.0313 21.486L20.6383 23.947C20.0623 23.837 18.9043 23.476 17.7123 22.287C16.5203 21.094 16.1593 19.933 16.0523 19.361L18.5113 16.967C18.6977 16.7861 18.8064 16.5398 18.8144 16.2802C18.8225 16.0206 18.7292 15.768 18.5543 15.576L14.8593 11.513C14.6843 11.3204 14.4412 11.2035 14.1814 11.1873C13.9217 11.171 13.6659 11.2567 13.4683 11.426L11.2983 13.287C11.1254 13.4605 11.0222 13.6914 11.0083 13.936C10.9933 14.186 10.7073 20.108 15.2993 24.702C19.3053 28.707 24.3233 29 25.7053 29C25.9073 29 26.0313 28.994 26.0643 28.992C26.3088 28.9783 26.5396 28.8747 26.7123 28.701L28.5723 26.53C28.7417 26.3325 28.8276 26.0768 28.8115 25.817C28.7954 25.5573 28.6788 25.3141 28.4863 25.139L24.4223 21.443Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone1.72ac6b3c9b0f05af8f5df3c4c7ace95a.svg";
export { ForwardRef as ReactComponent };